/* eslint-disable @next/next/no-img-element */
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  AccordionHead,
  Title,
  Desc,
  AccordionItem,
  AccordionDesktopDropdown,
  AccordionMobileDropdown,
  Rotate,
} from './styles';
import { useState } from 'react';
import parse from 'html-react-parser';
import Autolinker from 'autolinker';
import { ASSETS, TRAVELLER_DETAILS_ICONS } from 'src/common/utils/config';

import { useViewport } from 'src/common/utils/responsive';

const Index = ({ item, accordionItemStyles = {} }) => {
  const [open, setOpen] = useState(true);
  const options = {
    urls: { schemeMatches: true, tldMatches: false, ipV4Matches: true },
    phone: true,
    email: true,
  };
  const autolinker = Autolinker.link(item?.answer, options);
  const transformed = autolinker ? parse(autolinker) : item?.answer;
  const { isMobile } = useViewport();

  return (
    <AccordionItem
      onClick={() => setOpen(!open)}
      accordionItemStyles={accordionItemStyles}
    >
      <AccordionHead>
        <Title weight={open}>{item?.question}</Title>
        {isMobile ? (
          <AccordionMobileDropdown rotate={open}>
            <img
              src={TRAVELLER_DETAILS_ICONS.DROPDOWN}
              alt={'dropdown-icon'}
              width={'12px'}
              height={'12px'}
            />
          </AccordionMobileDropdown>
        ) : (
          <AccordionDesktopDropdown>
            <img
              src={ASSETS.MINUS}
              alt={'minus'}
              width={'14px'}
              height={'14px'}
            />
            <Rotate open={open}>
              <img
                src={ASSETS.MINUS}
                alt={'minus'}
                width={'14px'}
                height={'14px'}
              />
            </Rotate>
          </AccordionDesktopDropdown>
        )}
      </AccordionHead>
      <Desc open={open}>
        <div className="faq-anchor">{transformed}</div>
      </Desc>
    </AccordionItem>
  );
};

export default Index;
